import $moment from 'moment';
import store from '@/store';
import _get from 'lodash/get';

// 地区日期差格式化转换（唯一区别 时区反向偏移）
function $convertLocalDateToUTCDate ( sd, format = 'YYYY-MM-DD HH:mm:ss' ) {
	if ( !sd || Object.keys( sd ).length < 1 ) {
		return '';
	}
	// 时区差需要地区数据支撑
	let utcOffset = 0;
	const zones = store.state.countryList.find(( val ) => cc.toUpperCase() === val.id );
	if ( zones ) {
		try {
			utcOffset = JSON.parse( zones.timezones )[ 0 ].utcOffset;
		} catch ( error ) {
			console.log( error );
		}
	}
	return $moment.utc( sd ).utcOffset( -utcOffset ).
		format( format );
}

/**
 * 获取图片制定宽度和高度的缩略图，仅支持aliyun的oss储存的图片
 * 针对aws的服务图片，缩略图暂时用100尺寸的图片
 * @param {图片对像} imgObj
 * @param {缩放之后的宽度} width
 * @param {缩放之后的高度} height
 * @returns
 */
const $ossImageByWidthAndHeight = ( imgObj ) => {
	let cdnUrl = '';
	if ( !imgObj || !imgObj.bucket ) {
		return cdnUrl;
	}
	const w = imgObj.w || 100;
	const h = imgObj.h;
	const m = imgObj.m;
	const cdnUrlConfig = _get( store.state, 'global.cdnUrl', {});
	const cloud = _get( store.state, 'global.cloud', 'aliyun' );
	if ( !cdnUrlConfig[ imgObj.bucket ]){
  	return '';
	}
	if ( cloud === 'aliyun' ) {
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + imgObj.dfsID + `?x-oss-process=image/resize${m ? ',m_' + m : ''},w_${w}${h ? ',h_' + h : ''}`;
	} else if ( cloud === 'aws' ) {
		// 暂时用固定的尺寸，待后续调研
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + imgObj.w + 'xAUTO/' + imgObj.dfsID;
	}
	return cdnUrl;
};

export {
	$convertLocalDateToUTCDate,
	$ossImageByWidthAndHeight
};
